const IDUtils = {
    generateID() {
        const S4 = () => (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1) // eslint-disable-line no-bitwise
        return `${S4()}${S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`
    },
    generateSocketGroupIDContentPush() {
        return `cp-${new Date().getTime()}`
    },
    generateSocketGroupIDReboot() {
        return `re-${new Date().getTime()}`
    },
    generateSocketGroupIDScreenshot() {
        return `sc-${new Date().getTime()}`
    },
    generateSocketGroupIDSettingsPush() {
        return `sp-${new Date().getTime()}`
    },
}

export default IDUtils
